// src/lib/landingData.js
// ─────────────────────────────────────────────────────────────────────────────
// PAST GATHERINGS
// Add a new gathering by appending an object to this array.
// Data shape mirrors Instagram oEmbed fields for future automation.
// ─────────────────────────────────────────────────────────────────────────────

export const PAST_GATHERINGS = [
  {
    id: 'gathering-1',
    isoDate: '2025-08',
    date: 'Aug 2025',
    location: 'San Diego, CA',
    instagramUrl: 'https://www.instagram.com/p/DOHsd0kj-vE/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    images: [
      '/images/gatherings/DOHsd0kj-vE-1.jpg',
      '/images/gatherings/DOHsd0kj-vE-2.jpg',
    ],
    caption: 'Water for Plants 🌱 8.30.25',
  },
  {
    id: 'gathering-2',
    isoDate: '2025-09',
    date: 'Sep 2025',
    location: 'San Diego, CA',
    instagramUrl: 'https://www.instagram.com/p/DPMWze_iXNV/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    images: [
      '/images/gatherings/DPMWze_iXNV-1.jpg',
    ],
    caption: 'Water for Plants 🌱 9.27.25',
  },
  {
    id: 'gathering-3',
    isoDate: '2025-10',
    date: 'Oct 2025',
    location: 'San Diego, CA',
    instagramUrl: 'https://www.instagram.com/p/DQXNLRKkoV4/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
   images: [
      '/images/gatherings/DQXNLRKkoV4-1.jpg',
    ],
    caption: 'Water for Plants 🌱 10.25.25',
  },
  {
    id: 'gathering-4',
    isoDate: '2025-11',
    date: 'Nov 2025',
    location: 'San Diego, CA',
    instagramUrl: 'https://www.instagram.com/p/DR0t20BicQO/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
   images: [
      '/images/gatherings/DR0t20BicQO-1.jpg',
    ],
    caption: 'Water for Plants 🌱 11.29.25',
  },
  {
    id: 'gathering-5',
    isoDate: '2025-12',
    date: 'Dec 2025',
    location: 'San Diego, CA',
    instagramUrl: 'https://www.instagram.com/p/DS6A1z2EicG/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    images: [
      '/images/gatherings/DS6A1z2EicG-1.jpg',
      '/images/gatherings/DS6A1z2EicG-2.jpg',
      '/images/gatherings/DS6A1z2EicG-3.jpg',
      '/images/gatherings/DS6A1z2EicG-4.jpg',
      '/images/gatherings/DS6A1z2EicG-5.jpg',
    ],
    caption: 'Water for Plants 🌱 12.27.25',
  },
  {
    id: 'gathering-6',
    isoDate: '2026-01',
    date: 'Jan 2026',
    location: 'San Diego, CA',
    instagramUrl: 'https://www.instagram.com/p/DUT7b8EknAv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    images: [
      '/images/gatherings/DUT7b8EknAv-1.jpg',
      '/images/gatherings/DUT7b8EknAv-2.jpg',
      '/images/gatherings/DUT7b8EknAv-3.jpg',
      '/images/gatherings/DUT7b8EknAv-4.jpg',
    ],
    caption: 'This is Water for Plants 🌱',
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// RHYTHM VIDEOS
// Each entry maps to a single YouTube video card.
// youtubeId: the 11-character ID after watch?v= or /embed/
// ─────────────────────────────────────────────────────────────────────────────

export const RHYTHM_VIDEOS = [
  {
    id: 'rhythm-1',
    youtubeId: 'a43vL73yzoQ',
    date: 'Jan 2026',
    title: 'Night Drive',
    description:
      'Night Drive is a moving journal with songs for the in-between hours. Windows down, city lights blurred, no destination.\n\nPress play when you want company, not noise.',
    youtubeUrl: 'https://www.youtube.com/watch?v=a43vL73yzoQ',
  },
  {
    id: 'rhythm-2',
    youtubeId: 'a43vL73yzoQ',
    date: 'Jan 2026',
    title: 'Night Drive (Replay)',
    description:
      'A second pass through the city. Same streets, different feeling.',
    youtubeUrl: 'https://www.youtube.com/watch?v=a43vL73yzoQ',
  },
  {
    id: 'rhythm-3',
    youtubeId: 'a43vL73yzoQ',
    date: 'Feb 2026',
    title: 'Night Drive (Late Edition)',
    description:
      'After midnight. The city gets quieter but never fully silent.',
    youtubeUrl: 'https://www.youtube.com/watch?v=a43vL73yzoQ',
  },
];
